export default __webpack_public_path__ + "static/media/ic_totaluser.23060949.svg";